import React from 'react';

import { Marquee } from '$partials/ui';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ConversationMarqueeBlock}
 */
const ConversationMarqueeBlock = ({
    id,
    conversations
}) => {
    // Remove any duplicates
    const conversationTitles = [...new Set(conversations.map((c) => c.title))];

    return (
        <Marquee
            className='hidden sm:block py-[110px]'
            id={`conversations-${id}`}>
            {conversationTitles?.map((title, i) => {
                return (
                    <div
                        className='px-30 expand-interaction'
                        key={i}>
                        <p className='type-style-heading-2'>
                            {title}
                        </p>
                        <a
                            className='underline expand-interaction__action'
                            href='#booking'>
                            Join
                        </a> the conversation
                    </div>
                );
            })}
        </Marquee>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ConversationMarqueeBlock;
